export default __webpack_public_path__ + "static/media/facility_02_1.60cf392d.png";